<template>
  <div class="chatList">
    <!-- 聊天列表 -->
    <div v-if="token" class="searchBox">
      <a-input v-model="username" placeholder="搜索" class="searchBoxInput" @change="onSearchChatList">
        <template #prefix>
          <a-icon type="search" />
        </template>
      </a-input>
    </div>
    <a-spin :spinning="chatListSpinng">
      <div ref="chatListCont" class="chatListCont" @scroll.passive="onSearchChatList('getMore')">
        <div
          v-for="(item, index) in modalMsgList"
          :key="'chatItem' + index"
          class="chatListItem"
          :class="hoverItem === index ? 'hoverItem' : ''"
          @click="handleChatItem(item, index)"
        >
          <a-badge
            :offset="[-13, 0]"
            :count="(item.talkMessageLog && item.talkMessageLog.unReadNum) || 0"
            :overflow-count="9"
          >
            <v-img
              :src="
                ((item.toMemberCardVO && (item.toMemberCardVO.cardAvatar || item.toMemberCardVO.memberAvatar)) ||
                  DEFAULTS_AVATAR) + '?x-oss-process=image/resize,m_fixed,h_44,w_44'
              "
              :onerror="`this.src='${DEFAULTS_AVATAR}';this.onerror=null`"
              class="userIcon"
            />
          </a-badge>

          <div class="itemSimpleInfo">
            <div class="topTip">
              <span class="name">
                <!-- 游客, 现已弃用, 游客模块仅做兼容 -->
                <template v-if="!item.toMemberCardVO.roleId"
                  >{{ `${$t('游客')}` }}
                  <template
                    v-if="
                      item.toMemberCardVO.userName ||
                      item.toMemberCardVO.memberUserName ||
                      item.toMemberCardVO.ipLocation
                    "
                    >{{
                      `(${item.toMemberCardVO.userName || item.toMemberCardVO.memberUserName} ${
                        item.toMemberCardVO.ipLocation
                      })`
                    }}</template
                  >
                </template>
                <!-- 企业用户 -->

                <span
                  v-else-if="
                    item.toMemberCardVO.companyName &&
                    (item.toMemberCardVO.companyFlag === 0 ||
                      Number(item.toMemberCardVO.roleId) === 2 ||
                      Number(item.toMemberCardVO.roleId) === 3 ||
                      Number(item.toMemberCardVO.roleId) === 4)
                  "
                  :title="
                    item.toMemberCardVO.userName ||
                    item.toMemberCardVO.memberUserName + `(${item.toMemberCardVO.companyName})`
                  "
                >
                  {{ item.toMemberCardVO.userName || item.toMemberCardVO.memberUserName }}({{
                    item.toMemberCardVO.companyName
                  }})
                </span>
                <!-- 个人用户 -->
                <span v-else :title="item.toMemberCardVO.userName || item.toMemberCardVO.memberUserName">
                  {{ item.toMemberCardVO.userName || item.toMemberCardVO.memberUserName }}
                  ({{ item.toMemberCardVO.phone }}{{ item.toMemberCardVO.phone && item.toMemberCardVO.email ? '/' : ''
                  }}{{ item.toMemberCardVO.email }})
                </span>
              </span>
              <span class="time">{{ item.talkMessageLog.updateTime | momentTime }}</span>
            </div>
            <div class="purchaseIdentity">
              <div v-if="item.toMemberCardVO.purchaserFlag === 1" class="buyer">
                {{ $t('采') }}
              </div>
              <div v-if="item.toMemberCardVO.supplierFlag === 1" class="supplier">
                {{ $t('供') }}
              </div>
              <div v-if="item.toMemberCardVO.allianceFlag === 1" class="alliance">
                {{ $t('加') }}
              </div>
              <div v-if="item.toMemberCardVO.brandFlag === 1" class="brand">
                {{ $t('品') }}
              </div>
            </div>
            <span class="miniCont" v-html="formatTxt(item.talkMessageLog.lastMessage, '#aaabad')" />
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import throttle from 'lodash/throttle'
import moment from 'moment'
import { formatTxt } from '@/utils/util'
import { getChatList, syncMsgUnReadNum } from '@/api/pushSend'

// const
import { DEFAULTS_AVATAR_BIG, ICON_CHAT_DOT_RED, DEFAULTS_AVATAR } from '@/const/image'

export default {
  name: 'ChatList',
  filters: {
    momentTime(value) {
      if (!value) {
        return ''
      }
      return moment(value).format('MM-DD')
    },
  },
  data() {
    return {
      DEFAULTS_AVATAR_BIG,
      ICON_CHAT_DOT_RED,
      DEFAULTS_AVATAR,
      chatListSpinng: false,
      // 当前和谁聊天
      hoverItem: -1,
      username: '',
      // 洽谈列表当前页
      chatListCurrent: 1,
      chatListTotal: 0,
    }
  },
  computed: {
    ...mapGetters({
      // 判断是否正式登录
      token: 'token',
      modalMsgList: 'chat/modalMsgList',
      otherUserInfo: 'chat/otherUserInfo',
      // 洽谈的全部未读数(不包括admin的数据)
      talkUnReadNum: 'chat/talkUnReadNum',
    }),
  },
  methods: {
    formatTxt,

    // 获取聊天列表
    async getChatList() {
      this.chatListSpinng = true
      const { code, data } = await getChatList({
        current: this.chatListCurrent,
        size: 16,
      })
      this.chatListSpinng = false
      if (code === 0) {
        this.chatListTotal = data.total

        const modalMsgList = data.records.filter((item, index) => {
          if (item.toMemberCardVO && item.toMemberCardVO.huanxinId === this.otherUserInfo.huanxinId) {
            this.hoverItem = index
            console.log('过滤掉自己的消息', this.hoverItem)
            item.talkMessageLog.unReadNum = 0
          }
          if (item.toMemberCardVO) {
            return true
          }
        })

        const newInfo = JSON.parse(JSON.stringify(this.otherUserInfo))
        // 如果是新用户, 显示为第一位
        if (this.hoverItem === -1) {
          modalMsgList.unshift({
            talkMessageLog: {},
            toMemberCardVO: newInfo,
          })
          this.hoverItem = 0
        }

        this.$store.commit('chat/UPDATE_MODAL_MSG_LIST', JSON.parse(JSON.stringify(modalMsgList)))

        const that = this
        this.$WebIM.conn.getSessionList({
          async success(res) {
            if (res.data && res.data.channel_infos && res.data.channel_infos.length > 0) {
              let talkUnReadNum = 0

              that.$store.commit('chat/UPDATE_CHAT_SESSION_LIST', res.data.channel_infos)

              for (let i = 0; i < res.data.channel_infos.length; i++) {
                // 如果是管理员的消息, 不记录到总消息内
                if (
                  res.data.channel_infos[i].channel_id === '1115200522168856#yunexhibitionapp_admin@easemob.com' ||
                  (res.data.channel_infos[i].meta &&
                    res.data.channel_infos[i].meta.from === '1115200522168856#yunexhibitionapp_admin@easemob.com')
                ) {
                  that.$store.commit('chat/UPDATE_CHAT_ADMIN_UNREAD_NUM', res.data.channel_infos[i].unread_num)
                  continue
                }

                // 临时处理, 用户1925574558@qq.com 201000kong, 环信id 3411442029 收到的3505516395消息无法去除
                if (res.data.channel_infos[i].meta.id === '948955448462018628') {
                  continue
                }

                talkUnReadNum += res.data.channel_infos[i].unread_num

                const payload = JSON.parse(res.data.channel_infos[i].meta.payload)

                modalMsgList.map((item) => {
                  if (
                    payload.from.includes(item.toMemberCardVO.huanxinId) ||
                    payload.to.includes(item.toMemberCardVO.huanxinId)
                  ) {
                    item.talkMessageLog.unReadNum = res.data.channel_infos[i].unread_num
                  }
                })
              }

              that.$store.commit('chat/UPDATE_MODAL_MSG_LIST', modalMsgList)

              if (Number(talkUnReadNum) !== Number(that.talkUnReadNum)) {
                that.$store.commit('chat/UPDATE_CHAT_UNREAD_NUM', talkUnReadNum)
                await syncMsgUnReadNum({ unReadNum: talkUnReadNum })
              }

              // 切换用户
              that.$emit('switchUser')
              that.$forceUpdate()
            }
          },
        })
      }
    },
    /**
     * @description:搜索聊天列表, 或者下拉加载更多
     * @param {*} async
     * @return {*}
     */
    onSearchChatList: throttle(async function (type) {
      console.log('onSearchChatList', type)

      const that = this

      if (type === 'getMore') {
        console.log(
          'getMore',
          that.$refs.chatListCont?.scrollTop,
          that.$refs.chatListCont?.scrollHeight,
          that.$refs.chatListCont?.clientHeight,
        )
        if (
          that.$refs.chatListCont?.scrollTop >=
            that.$refs.chatListCont?.scrollHeight - that.$refs.chatListCont?.clientHeight - 200 &&
          that.modalMsgList.length < that.chatListTotal
        ) {
          that.chatListCurrent += 1
        } else {
          return
        }
      } else {
        that.chatListCurrent = 1
      }

      that.chatListSpinng = true

      const info = {
        current: that.chatListCurrent,
        size: 16,
      }

      if (that.username) {
        info.username = that.username
      }
      const { code, data } = await getChatList(info)

      if (code === 0) {
        that.chatListTotal = data.total
        let modalMsgList = data.records.filter((item, index) => {
          if (item.toMemberCardVO && item.toMemberCardVO.huanxinId === that.otherUserInfo.huanxinId) {
            that.hoverItem = index
            item.talkMessageLog.unReadNum = 0
          }
          if (item.toMemberCardVO) {
            return true
          }
        })

        if (type === 'getMore') {
          const oldModalMsgList = JSON.parse(JSON.stringify(that.modalMsgList))

          modalMsgList = oldModalMsgList.concat(modalMsgList)
          console.log('getmore', modalMsgList)
        }

        that.$store.commit('chat/UPDATE_MODAL_MSG_LIST', modalMsgList)
      }
      that.chatListSpinng = false
    }, 1000),
    // 点击洽谈的用户
    handleChatItem(item, index) {
      console.log('点击洽谈的用户', item, index, item.toMemberCardVO)
      this.hoverItem = index

      // 可能有多个洽谈对象, 不能在组件中用linkInfo
      this.$store.commit('chat/SWITCH_OTHER_INFO', item.toMemberCardVO)
      this.$emit('switchUser')
    },
  },
}
</script>

<style lang="scss" scoped>
.chatList {
  position: relative;
  width: 240px;
  height: 100%;
  background: #f1f1f3;
  .searchBox {
    position: relative;
    width: 100%;
    height: 60px;
    background: #f7f7f9;
    .searchBoxInput {
      position: relative;
      width: 90%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .chatListCont {
    height: 700px;
    width: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .chatListItem {
    display: flex;
    align-items: center;
    padding: 10px 10px 10px 15px;
    cursor: pointer;
    .userIcon {
      width: 44px;
      height: 44px;
      background: #cbccce;
      border-radius: 6px;
      margin-right: 15px;
    }
    .itemSimpleInfo {
      width: 100%;
      .topTip {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 145px;
        > .name {
          @include text-ellipsis(1);
          font-size: 14px;
          max-width: 60%;
          font-weight: bold;
          color: #333333;
          word-break: break-all;
        }
        > .time {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
        }
      }

      .miniCont {
        @include text-ellipsis(1);
        font-size: 14px;
        color: #aaabad;
      }
    }

    &.hoverItem {
      background: #e4e4e8;
    }
  }
}

.purchaseIdentity {
  position: relative;
  width: 100%;
  display: flex;
  > div {
    padding: 0 2px;
    height: 18px;
    line-height: 18px;
    border-radius: 2px;
    display: inline-block;
    margin-right: 4px;
    color: #ffffff;
  }
  .buyer {
    background: #3386f1;
    border-radius: 2px;
    display: inline-block;
  }
  .supplier {
    background: #ff6600;
  }
  .alliance {
    background: #f54342;
  }
  .brand {
    background: #485aeb;
  }
}
</style>
